import eventBus from '@/js/eventbus'

export default {
  data () {
    return {
      editMode: false
    }
  },
  computed: {
    insideOverviewOrIPPage() {
      return (this.$route.name === 'investmentPitch' || this.$route.name === 'companyOverview')
    }
  },
  mounted () {
    const self = this
    eventBus.$on('edit-mode', (editMode) => {
      console.log('EDIT MODE HERE WE COME', editMode)
      self.editMode = editMode
    })
  }
}
